

import "../styles/addnew.css";
import React, { useState, useEffect } from "react";

function OperPopup({ closePopup, editData }) {
  // Form field states
  const [code, setCode] = useState("");
  const [name, setName] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const token ="eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczovL2FwaS11YXQubWF3YWxvZy5jb20vYWRtaW4vdjIvYXBpL2xvZ2luIiwiaWF0IjoxNzQyMzYwMzE5LCJleHAiOjE3NDI0NDY3MTksIm5iZiI6MTc0MjM2MDMxOSwianRpIjoiV0NWdnFTUlFHaUdIWGRDbiIsInN1YiI6IjQyMSIsInBydiI6IjlhZDU4NTc3ZmFiNmZiYzE1NTQzNGQzNTkxZWRmMTY0YTE3NzY1YWEiLCJhdXRoaWQiOjQyMSwib3JnaWQiOjEwMCwidXNlcmlkIjo0MjEsImRhdGFiYXNlbmFtZSI6InJhZ3VyciIsIm9yZ19jb2RlIjoicmFndXJyIiwidGltZXpvbmUiOiIgKyBpbnRlcnZhbCAnMDUgaG91cnMgMzAgbWludXRlcyciLCJyb2xlaWQiOjQwMSwicGF5bWVudF9zdGF0dXMiOnRydWUsImF1dGhvcml0aWVzIjpbIlJPTEVfVVNFUiJdfQ.pPaDze1XzNbwd_Ac7aeB8L_Gq2ebSNt8Y7kKzY66V1o"; // 🔒 Use env variable for security


  useEffect(() => {
    console.log("Popup received editData:", editData); // Debugging
  
    if (editData?.id) { // ✅ If ID exists, fetch latest data
      const fetchData = async () => {
        try {
          const response = await fetch(
            `https://api-uat.mawalog.com/cost_design/v1/api/costsolution/operationarea/get/${editData.id}`,
            {
              method: "GET",
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
            }
          );
  
          if (!response.ok) throw new Error("Failed to fetch data");
  
          const data = await response.json();
          console.log("Fetched Data:", data); // Debugging
  
          // ✅ Ensure correct field mapping
          setCode(data.operationarea?.code || "");
          setName(data.operationarea?.name || "");
          setIsEditing(true);
        } catch (error) {
          console.error("Error fetching data:", error);
          alert("Error fetching details");
        }
      };
  
      fetchData();
    } else {
      setCode("");
      setName("");
      setIsEditing(false);
    }
  }, [editData]);
    
  

  const handleSubmit = async (e) => {
    e.preventDefault();
    const postData = { code, name };

    try {
     
      const url = isEditing
        ? `https://api-uat.mawalog.com/cost_design/v1/api/costsolution/operationarea/${editData?.id}`
        : "https://api-uat.mawalog.com/cost_design/v1/api/costsolution/operationarea";

        console.log("Request Method:", isEditing ? "PUT" : "POST"); // ✅ Check method
        console.log("Request URL:", url); // ✅ Check URL

        const response = await fetch(url, {
          method: isEditing ? "PUT" : "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(postData),
        });

      const data = await response.json();
      console.log("Response:", data);

      if (response.ok) {
        alert(isEditing ? "Data updated successfully!" : "Data saved successfully!");
        setCode("");
        setName("");
        closePopup();
      } else {
        alert("Error: " + (data.message || "Failed to process request"));
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Something went wrong!");
    }
  };

  const handleClear = () => {
    setCode("");
    setName("");
  };

  
  return (
    <div className="popup-form">
      <div className="form-container">
        {/* Close Button */}

        <span className="close-btn" onClick={closePopup}>
          <svg width="34" height="35" viewBox="0 0 34 35" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.4869 10.5041C10.3883 10.5147 10.2948 10.5531 10.2171 10.6149C10.1395 10.6766 10.081 10.7592 10.0484 10.853C10.0159 10.9468 10.0106 11.0479 10.0333 11.1446C10.0559 11.2412 10.1055 11.3295 10.1763 11.399L16.2588 17.4942L10.1763 23.584C10.1227 23.6314 10.0795 23.6894 10.0492 23.7543C10.0189 23.8192 10.0022 23.8897 10.0002 23.9613C9.99818 24.0328 10.0108 24.1041 10.0374 24.1706C10.064 24.2371 10.1039 24.2975 10.1546 24.3479C10.2054 24.3984 10.266 24.4379 10.3326 24.464C10.3992 24.4901 10.4705 24.5022 10.542 24.4997C10.6135 24.4971 10.6837 24.4799 10.7483 24.4491C10.8129 24.4183 10.8705 24.3746 10.9175 24.3206L17 18.2309L23.0825 24.3206C23.1295 24.3746 23.1871 24.4183 23.2517 24.4491C23.3163 24.4799 23.3865 24.4971 23.458 24.4997C23.5295 24.5022 23.6008 24.4901 23.6674 24.464C23.734 24.4379 23.7946 24.3984 23.8454 24.3479C23.8961 24.2975 23.936 24.2371 23.9626 24.1706C23.9892 24.1041 24.0018 24.0328 23.9998 23.9613C23.9978 23.8897 23.9811 23.8192 23.9508 23.7543C23.9205 23.6894 23.8773 23.6314 23.8237 23.584L10.9175 10.6623C10.8625 10.605 10.7951 10.5609 10.7205 10.5335C10.6459 10.506 10.566 10.496 10.4869 10.5041ZM23.3932 10.5041C23.2746 10.5197 23.1649 10.5756 23.0825 10.6623L17.6758 16.0754C17.6223 16.1229 17.5791 16.1809 17.5488 16.2458C17.5185 16.3107 17.5019 16.3811 17.4998 16.4527C17.4978 16.5243 17.5105 16.5955 17.537 16.662C17.5636 16.7285 17.6035 16.7889 17.6543 16.8393C17.705 16.8898 17.7656 16.9293 17.8322 16.9554C17.8988 16.9815 17.9701 16.9936 18.0416 16.9911C18.113 16.9885 18.1832 16.9713 18.2478 16.9406C18.3124 16.9098 18.37 16.8661 18.4171 16.8121L23.8237 11.399C23.9022 11.3224 23.9547 11.223 23.9737 11.1149C23.9928 11.0068 23.9774 10.8954 23.9298 10.7965C23.8823 10.6976 23.8049 10.6162 23.7086 10.5637C23.6123 10.5113 23.5019 10.4904 23.3932 10.5041Z" fill="#5E5E5E" />
          </svg>
        </span>

        <h2 className="heading">{isEditing ? "Edit Operation Area" : "Create New Operation Area"}</h2>
        <form onSubmit={handleSubmit}>
          <label htmlFor="code" className="labels">Code</label>
          <input
            type="text"
            id="code"
            name="code"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            required
          /><br /><br />

          <label htmlFor="category" className='name'>Name</label>
          <input
            type="text"
            id="name"
            name="name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          /><br /><br />

          {/* Clear, Submit/Update Buttons */}
          <div className="button-group">
            <button type="button" className='clear' onClick={handleClear}>Clear</button>
            <input type="submit" value={isEditing ? "Save" : "Submit"} className='submit-button' />
          </div>


        </form>
      </div>
    </div>
  );
}

export default OperPopup;
